import { render, staticRenderFns } from "./m-card.vue?vue&type=template&id=323ab982&"
import script from "./m-card.vue?vue&type=script&lang=js&"
export * from "./m-card.vue?vue&type=script&lang=js&"
import style0 from "./m-card.vue?vue&type=style&index=0&id=323ab982&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports